module.exports = __webpack_public_path__ + "img/article.ec23abb1.jpg";